// Hook (use-require-auth.js) (https://usehooks.com/)
import { useEffect } from "react";
import { useAuth } from "./use-auth.js";
import { useRouter } from "./use-router.js";

export function useRequireAuth(redirectUrl = "/login") {
  const auth = useAuth();
  const router = useRouter();
  // If auth.user is false that means we're not
  // logged in and should redirect.
  useEffect(() => {
    if (auth.user === false) {
      auth.setRedirectUrl(router.location.pathname);
      console.log(router.location.pathname);
      router.push(redirectUrl);
    }
  }, [auth, router]);
  return auth;
}